export default {
    primary: 
    {
      50: '#d9fffa',
      100: '#adfff1',
      200: '#7dffe8',
      300: '#4dffdf',
      400: '#25ffd6',
      500: '#13e6bc',
      600: '#00b392',
      700: '#008069',
      800: '#004e3f',
      900: '#001c15',
    },
    dark: 
    {
      50: '#e8f4fc',
      100: '#cadbe8',
      200: '#a9c3d6',
      300: '#88aac5',
      400: '#6693b4',
      500: '#4e799b',
      600: '#3c5f79',
      700: '#2a4457',
      800: '#172935',
      900: '#020f16',
    },
    light: 
    {
      50: '#eff5f5',
      100: '#d6e0e0',
      200: '#b9cdcd',
      300: '#9cb9b9',
      400: '#80a6a6',
      500: '#668c8c',
      600: '#516e6e',
      700: '#3b4e4e',
      800: '#232f2f',
      900: '#0a1010',
    }
}